(function () {
  const sidebar = document.querySelector('.container.reading-width');
  const description = document.querySelector('.accordion-content-wrapper');
  const reference = document.querySelector('#product-media');
  const productInfo = document.querySelector('.product-info');
  const maxHeightAttr = parseInt(description?.getAttribute('data-description-height') || '150', 10);

  if (!sidebar || !description || !reference || !productInfo) return;

  const originalStyles = {
    position: sidebar.style.position,
    top: sidebar.style.top,
    left: sidebar.style.left,
    width: sidebar.style.width,
    zIndex: sidebar.style.zIndex,
  };

  let lastDetailsOpen = false;

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function anyDetailsOpen() {
    return Array.from(sidebar.querySelectorAll('details')).some(d => d.open);
  }

  function resetSidebar() {
    sidebar.style.position = originalStyles.position || '';
    sidebar.style.top = originalStyles.top || '';
    sidebar.style.left = originalStyles.left || '';
    sidebar.style.width = originalStyles.width || '';
    sidebar.style.zIndex = originalStyles.zIndex || '';
  }

  function applySticky() {
    if (window.innerWidth <= 1024) {
      resetSidebar();
      return;
    }

    const sidebarHeight = sidebar.scrollHeight;
    const refRect = reference.getBoundingClientRect();
    const infoRect = productInfo.getBoundingClientRect();
    const detailsOpen = anyDetailsOpen();

    if (detailsOpen && !lastDetailsOpen) {
      resetSidebar();
      description.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (detailsOpen) {
      lastDetailsOpen = true;
      return;
    }

    lastDetailsOpen = false;

    const shouldStick =
      !isInViewport(reference) &&
      isInViewport(productInfo) &&
      sidebarHeight > maxHeightAttr &&
      infoRect.bottom > sidebarHeight + 100;

    if (!shouldStick) {
      resetSidebar();
      return;
    }

    sidebar.style.position = 'fixed';
    sidebar.style.top = '100px';
    sidebar.style.left = `${refRect.left}px`;
    sidebar.style.width = `${refRect.width}px`;
    sidebar.style.zIndex = '1000';
  }

  sidebar.querySelectorAll('details').forEach((detail) => {
    detail.addEventListener('toggle', () => {
      setTimeout(applySticky, 50);
    });
  });

  window.addEventListener('scroll', applySticky);
  window.addEventListener('resize', applySticky);
  setInterval(applySticky, 300);
})();
